import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BotaoOuvir from "../components/BotaoOuvir";
import AdminBotao from "./AdminBotao";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

function pegarToken() {
  try {
    return localStorage.getItem("token") || localStorage.getItem("giraia_curso_token") || "";
  } catch (e) {
    return "";
  }
}

async function chamar(caminho, opcoes) {
  const resp = await fetch(API + caminho, Object.assign({}, opcoes, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + pegarToken() },
  }));
  let dados = null;
  try { dados = await resp.json(); } catch (e) {}
  if (!resp.ok) {
    const det = (dados && dados.detail) || "";
    if (resp.status === 401 || det === "Not authenticated") throw new Error("Voc\u00ea precisa entrar na sua conta para continuar.");
    if (det === "Forbidden") throw new Error("Esta conta n\u00e3o tem permiss\u00e3o para ver esta p\u00e1gina.");
    throw new Error(det || "Erro " + resp.status);
  }
  return dados;
}

function urlVideo(url) {
  if (!url) return null;
  let m = url.match(/youtube\.com\/watch\?v=([\w-]+)/) || url.match(/youtu\.be\/([\w-]+)/);
  if (m) return { tipo: "iframe", src: "https://www.youtube.com/embed/" + m[1] };
  m = url.match(/vimeo\.com\/(\d+)/);
  if (m) return { tipo: "iframe", src: "https://player.vimeo.com/video/" + m[1] };
  return { tipo: "video", src: url };
}

function renderTexto(texto) {
  return (texto || "").split("\n").map((linha, i) => {
    if (linha.startsWith("## ")) return <h2 key={i} className="text-[#F2F0EA] text-2xl font-bold mt-8 mb-3">{linha.slice(3)}</h2>;
    if (linha.startsWith("- ")) return <p key={i} className="text-lg leading-8 mb-2 pl-4">{"\u2022 " + linha.slice(2)}</p>;
    if (linha.trim() === "") return null;
    return <p key={i} className="text-lg leading-8 mb-4">{linha}</p>;
  });
}

function Topo() {
  const zap = "https://wa.me/5566999584198?text=";
  return (
    <div className="max-w-2xl mx-auto mb-6 flex items-center justify-between gap-3">
      <a href="/loja-publica" className="flex items-center gap-2">
        <img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-12 h-12 rounded-full object-cover" />
        <span className="font-bold text-gold-500 hidden sm:inline">Giraia Bike Shop</span>
      </a>
      <div className="flex items-center gap-2 text-sm font-semibold">
        <a href="/loja-publica" className="px-3 py-2 rounded-lg border border-gold-500 text-gold-500">Loja</a>
        <a href="/indicar" className="px-3 py-2 rounded-lg border border-gold-500 text-gold-500">Indicar</a>
          <AdminBotao />
        <a href={zap + encodeURIComponent("Ol\u00e1! Vim pelo curso da Giraia.")} target="_blank" rel="noopener noreferrer" className="px-3 py-2 rounded-lg bg-gold-500 text-[#141118]">WhatsApp</a>
      </div>
    </div>
  );
}

export default function AreaAlunoPage() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);
  const [modulo, setModulo] = useState(null);
  const [respostas, setRespostas] = useState([]);
  const [resultado, setResultado] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const logado = !!pegarToken();

  async function carregarLista() {
    try {
      setDados(await chamar("/cursos"));
      setErro("");
    } catch (e) {
      setErro(e.message);
    }
    setCarregando(false);
  }

  useEffect(() => {
    if (logado) carregarLista();
    else setCarregando(false);
    // eslint-disable-next-line
  }, []);

  async function abrirModulo(numero) {
    setErro("");
    setResultado(null);
    try {
      const d = await chamar("/cursos/" + numero + "/conteudo");
      setModulo(d.modulo);
      setRespostas([]);
      window.scrollTo(0, 0);
    } catch (e) {
      setErro(e.message);
    }
  }

  async function enviarQuiz() {
    setEnviando(true);
    setErro("");
    try {
      const d = await chamar("/cursos/" + modulo.numero + "/quiz", { method: "POST", body: JSON.stringify({ respostas: respostas }) });
      setResultado(d);
      if (d.aprovado) carregarLista();
    } catch (e) {
      setErro(e.message);
    }
    setEnviando(false);
  }

  if (!logado) {
    return (
      <div className="min-h-screen bg-[#141118] text-[#F2F0EA] flex items-center justify-center p-6">
        <div className="bg-[#1E1A24] rounded-xl shadow p-8 max-w-md text-center">
          <h1 className="text-[#F2F0EA] text-2xl font-bold mb-3">{"\u00c1rea do Aluno"}</h1>
          <p className="text-[#B8B3A8] mb-5">{"Já tem conta? Entre para continuar. Primeira vez? Comece pela aula grátis, com certificado."}</p>
          <Link to="/login" className="inline-block bg-gold-500 text-[#141118] px-6 py-3 rounded-lg font-semibold mr-2">Entrar</Link>
          <Link to="/curso/gratis" className="inline-block border border-gold-500 text-gold-500 px-6 py-3 rounded-lg font-semibold mt-3">{"Começar aula grátis"}</Link>
        </div>
      </div>
    );
  }

  if (carregando) {
    return <div className="min-h-screen flex items-center justify-center text-[#9A948A]">Carregando...</div>;
  }

  const progresso = (dados && dados.progresso) || {};
  const comprados = progresso.modulos_comprados || [];
  const concluidos = progresso.modulos_concluidos || [];
  const lista = (dados && dados.modulos) || [];
  const completo = lista.length > 0 && concluidos.length >= lista.length;

  if (modulo) {
    const vid = urlVideo(modulo.video_url);
    const quiz = modulo.quiz || [];
    const respondidas = quiz.filter((q, i) => respostas[i] !== undefined).length;
    return (
      <div className="min-h-screen bg-[#141118] text-[#F2F0EA] p-4 sm:p-8">
        <Topo />
        <div className="max-w-2xl mx-auto bg-[#1E1A24] rounded-xl shadow p-6">
          <button onClick={() => { setModulo(null); setResultado(null); }} className="text-sm text-[#9A948A] mb-4">{"\u2190 Voltar aos m\u00f3dulos"}</button>
          <h1 className="text-[#F2F0EA] text-2xl font-bold mb-4">{"M\u00f3dulo " + modulo.numero + " - " + modulo.titulo}</h1>
          {vid && vid.tipo === "iframe" && (
            <div className="mb-5" style={{ position: "relative", paddingTop: "56.25%" }}>
              <iframe title="video" src={vid.src} allowFullScreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }} />
            </div>
          )}
          {vid && vid.tipo === "video" && <video controls src={vid.src} className="w-full mb-5 rounded-lg" />}
          <p className="text-sm text-[#b9b4aa] mb-3">Conteúdo atualizado em outubro/2026</p>
          <BotaoOuvir texto={modulo.conteudo_texto} />
          <div className="text-[#F2F0EA] mb-8">{renderTexto(modulo.conteudo_texto)}</div>
          {quiz.length > 0 && (
            <div id="quiz-topo" className="border-t pt-6">
              <h2 className="text-[#F2F0EA] text-xl font-bold mb-4">{"Quiz do m\u00f3dulo"}</h2>
              {quiz.map((q, i) => {
                const opcoes = q.opcoes || q.alternativas || q.options || [];
                const numerica = typeof q.resposta_correta === "number";
                return (
                  <div key={i} className="mb-5">
                    <p className="font-semibold text-lg mb-3">{(i + 1) + ". " + (q.pergunta || q.texto || q.question)}</p>
                    {opcoes.map((op, j) => {
                      const valor = numerica ? j : op;
                      return (
                        <label key={j} className={"block mb-3 p-3 rounded-lg border cursor-pointer text-lg " + (resultado && q.resposta_correta !== undefined ? (valor === q.resposta_correta ? "border-green-500 bg-green-900/30" : respostas[i] === valor ? "border-red-500 bg-red-900/30" : "border-[#3a3440] opacity-60") : "border-gold-500")}>
                          <input type="radio" disabled={!!resultado} name={"q" + i} checked={respostas[i] === valor} onChange={() => { const r = respostas.slice(); r[i] = valor; setRespostas(r); }} />
                          <span className="ml-2">{op}</span>
                        </label>
                      );
                    })}
                    {resultado && q.resposta_correta !== undefined && (respostas[i] === q.resposta_correta
                      ? <p className="text-green-400 font-semibold mt-1">{"\u2705 Acertou!"}</p>
                      : <p className="text-red-400 font-semibold mt-1">{"\u274C Resposta certa: " + (numerica ? opcoes[q.resposta_correta] : q.resposta_correta)}</p>)}
                    {resultado && q.explicacao && <p className="text-[#B8B3A8] mt-1">{q.explicacao}</p>}
                  </div>
                );
              })}
              {!resultado && <button onClick={enviarQuiz} disabled={enviando || respondidas < quiz.length} className="bg-gold-500 text-[#141118] px-6 py-3 rounded-lg font-semibold disabled:opacity-40">{enviando ? "Enviando..." : "Enviar respostas"}</button>}
              {resultado && (
                <div className={"mt-4 p-4 rounded-lg " + (resultado.aprovado ? "bg-green-100 text-green-900" : "bg-red-100 text-red-900")}>
                  {resultado.aprovado
                    ? "Parab\u00e9ns! Voc\u00ea acertou " + resultado.acertos + " de " + resultado.total + " e concluiu este m\u00f3dulo."
                    : "Voc\u00ea acertou " + resultado.acertos + " de " + resultado.total + ". Releia o conte\u00fado e tente de novo."}
                </div>
              )}
            </div>
          )}
          {resultado && (
            <div className="mt-4 flex flex-wrap gap-3">
              <button onClick={() => { setRespostas([]); setResultado(null); const el = document.getElementById("quiz-topo"); if (el) el.scrollIntoView({ behavior: "smooth" }); }} className="border border-gold-500 text-gold-500 px-5 py-3 rounded-lg font-semibold">{"\u21BB Refazer o quiz"}</button>
              <button onClick={() => { setModulo(null); setResultado(null); window.scrollTo(0, 0); }} className="bg-gold-500 text-[#141118] px-5 py-3 rounded-lg font-semibold">{"Voltar aos m\u00f3dulos"}</button>
            </div>
          )}
          {erro && <p className="mt-4 text-red-600">{erro}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] p-4 sm:p-8">
        <Topo />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-[#F2F0EA] text-3xl font-bold mb-2">{"\u00c1rea do Aluno"}</h1>
        <p className="text-[#B8B3A8] mb-6">{"Curso de seguran\u00e7a para patinetes, bikes elétricas e scooters - Giraia Bike Shop"}</p>
        {erro && <p className="mb-4 text-red-600">{erro}</p>}
        {comprados.length === 0 && (
          <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-6 text-yellow-900">
            {"Voc\u00ea ainda n\u00e3o tem m\u00f3dulos liberados. Se j\u00e1 pagou o PIX, aguarde a confirma\u00e7\u00e3o, que \u00e9 feita manualmente."}
          </div>
        )}
        {lista.map((m) => {
          const liberado = comprados.indexOf(m.numero) !== -1;
          const feito = concluidos.indexOf(m.numero) !== -1;
          return (
            <div key={m.numero} className="bg-[#1E1A24] rounded-xl shadow p-5 mb-3 flex items-center justify-between">
              <div>
                <p className="font-semibold">{"M\u00f3dulo " + m.numero + " - " + m.titulo}</p>
                <p className="text-sm text-[#9A948A]">{feito ? "Conclu\u00eddo" : liberado ? "Liberado" : "Bloqueado"}</p>
              </div>
              {liberado ? (
                <button onClick={() => abrirModulo(m.numero)} className="bg-gold-500 text-[#141118] px-4 py-2 rounded-lg text-sm font-semibold">{feito ? "Rever" : "Come\u00e7ar"}</button>
              ) : (
                (m.numero !== 1 && concluidos.indexOf(1) === -1) ? (<span className="text-sm text-[#9A948A] text-right max-w-[45%]">{"Faça o Módulo 1 grátis primeiro"}</span>) : (<Link to={m.numero === 1 ? "/curso/gratis" : "/curso/comprar/" + m.numero} className="border border-gold-500 text-gold-500 text-[#F2F0EA] px-4 py-2 rounded-lg text-sm font-semibold">{m.numero === 1 ? "Grátis" : "Comprar"}</Link>)
              )}
            </div>
          );
        })}
        {completo && (
          <div className="bg-green-100 text-green-900 rounded-xl p-5 mt-4 text-center font-semibold">
            {"Voc\u00ea concluiu todos os m\u00f3dulos! Fale com a Giraia Bike Shop pelo WhatsApp para receber seu certificado."}
          </div>
        )}
      </div>
    </div>
  );
}
